import React from 'react'
import { connect } from 'react-redux'

import { saveProfile } from 'store/entities/identity/actions'

import TimePreferencesForm from 'app/domains/common/TimePreferencesForm'
import Footer from '../Footer'
import { getTimeNotifications, isHasIrregularWorkWeek } from 'store/entities/identity/selectors'

const mapStateToProps = state => ({
  initialValues: getTimeNotifications(state),
  children: <Footer />,
  isHasIrregularWorkWeek: isHasIrregularWorkWeek(state),
})

const mapDispatchToProps = {
  onSubmit: saveProfile,
}

export default connect(mapStateToProps, mapDispatchToProps)(TimePreferencesForm)
